import { Checkbox } from '@mui/material'
import { GenericDisplayFlex } from 'src/mentor/layout/Styles'
import {
  GenericModalHeadlineLevelTwo,
  StyledInputBoxModal,
  StyledTextAreaBoxModal,
} from 'src/mentor/components/MentorAvailabilityPage/MentorAvailabilityPageStyles'

export default function EventBasicFields({ basicEventObject, setBasicEventObject, isDisabled }) {
  return (
    <>
      <GenericDisplayFlex>
        <div>Enabled</div>
        <Checkbox
          size="small"
          sx={{
            padding: 0,
            marginLeft: 1,
            '&.Mui-checked': {
              color: 'blue',
            },
          }}
          checked={basicEventObject?.enabled}
          onChange={(event) => {
            const { checked } = event.target
            setBasicEventObject((prev) => ({ ...prev, enabled: checked }))
          }}
          disabled={isDisabled}
        />
      </GenericDisplayFlex>

      <div style={{ fontStyle: 'italic' }}>
        Note that Disabled sessions are not listed in the app.
      </div>

      <div>
        <GenericModalHeadlineLevelTwo>Event Title (Publicly Visible)</GenericModalHeadlineLevelTwo>
        <StyledInputBoxModal
          value={basicEventObject?.title}
          onChange={(e) =>
            setBasicEventObject((prev) => ({
              ...prev,
              title: e.target.value,
            }))
          }
          disabled={isDisabled}
        />
      </div>

      <div>
        <GenericModalHeadlineLevelTwo>
          Event Description (Publicly Visible)
        </GenericModalHeadlineLevelTwo>
        <StyledTextAreaBoxModal
          value={basicEventObject?.description}
          onChange={(e) =>
            setBasicEventObject((prev) => ({
              ...prev,
              description: e.target.value,
            }))
          }
          disabled={isDisabled}
        />
      </div>
    </>
  )
}
